import { render, staticRenderFns } from "./kw_work_plat.vue?vue&type=template&id=d56d10c4&scoped=true&"
import script from "./kw_work_plat.vue?vue&type=script&lang=js&"
export * from "./kw_work_plat.vue?vue&type=script&lang=js&"
import style0 from "./kw_work_plat.vue?vue&type=style&index=0&id=d56d10c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56d10c4",
  null
  
)

component.options.__file = "kw_work_plat.vue"
export default component.exports